import * as IoC from 'typescript-ioc';
import { IAlertsService } from '../../../../infrastructure/alerts';
import { IEmailTemplatesDAO, IEmailVariable } from '../../../../api/email-templates.dao';
import { IGlobalStorage } from '../../../../infrastructure/global-storage';
import { action, observable } from 'mobx';
import { EMAIL_LIST_TYPE } from '../../../../constants/email-variables.constants';

class EmailVariablesFormVM {
    @observable
    private variablesList: IEmailVariable[] = [];
    @observable
    private isLoading: boolean;

    constructor(
        private readonly type: EMAIL_LIST_TYPE,
        @IoC.Inject private readonly alertsService: IAlertsService = IoC.Container.get(IAlertsService),
        @IoC.Inject private readonly emailTemplatesDAO: IEmailTemplatesDAO = IoC.Container.get(IEmailTemplatesDAO),
        @IoC.Inject private readonly globalStorage: IGlobalStorage = IoC.Container.get(IGlobalStorage),
    ) { }

    public get variables(): IEmailVariable[] {
        return this.variablesList;
    }

    public get loading(): boolean {
        return this.isLoading;
    }

    @action
    public initialize = async (): Promise<void> => {
        try {
            this.isLoading = true;
            const params = {
                accountId: this.globalStorage.getAccount().accountId,
                type: this.type
            };
            const response = await this.emailTemplatesDAO.getEmailVariables(params);
            this.parseResponseList(response);
        } catch (e) {
            this.alertsService.alert(e);
        } finally {
            this.isLoading = false;
        }
    };

    private parseResponseList = (list: IEmailVariable[]): void => {
        this.variablesList = list.map(x => {
            return {
                value: `{{${x.value}}}`,
                description: x.description
            };
        });
    };
}

export { EmailVariablesFormVM };
